import { ChangeEvent, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

import { CustomInput } from '../../../shared/uiComponents';

const SIGNATURE_INFO_TEXT = `Signatures for this form may be executed
by the user checking a signature box. The
effect of checking the signature box shall
be binding to the same extent, and shall
have the same effect, as with a manual
signature`;

const SignatureInput = ({
	disabled,
	onBlur,
	setValue,
	value,
	error,
	label = 'Signature:',
}: {
	disabled: boolean;
	error: boolean;
	label?: string;
	onBlur: () => void;
	setValue: (event: ChangeEvent<HTMLInputElement>) => void;
	value: string;
}) => {
	const [showInfo, setShowInfo] = useState<boolean>(false);

	const toggleSignatureInfoHandler = () => {
		setShowInfo((prev) => !prev);
	};

	return (
		<div style={{ position: 'relative', width: '250px' }}>
			<CustomInput
				label={label}
				value={value}
				onChange={setValue}
				className="marginBottom8 signature"
				error={error}
				disabled={disabled}
				onBlur={onBlur}
				endAdornment={<FontAwesomeIcon icon={faCircleInfo} onClick={toggleSignatureInfoHandler} />}
				description={showInfo ? SIGNATURE_INFO_TEXT : ''}
			/>
		</div>
	);
};

export default SignatureInput;
